import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { WEB_URL } from "../../api/URLs";
import { GTM_EVENTS } from "../../constants";
import { MixPanelTrackedLink } from "../../components";
import { HomeSvgOne, HomeSvgTwo, HomeSvgThree } from "../../components/Icons";

export default function () {
    const steps = [
        {
            count: 1,
            subtitle: "It only takes a minute to set up your fundraising page!",
            content: "Just set a goal, give your page a name and add a powerful image. That’s all you need to start raising funds to support the cause.",
            svg: HomeSvgOne
        }, {
            count: 2,
            subtitle: "Share your fundraiser with friends, family, and colleagues.",
            content: "Let everyone know you believe in the power of education. The more people you tell, the quicker you’ll reach your goal.",
            svg: HomeSvgTwo
        }, {
            count: 3,
            subtitle: "Celebrate your success.",
            content: "Every penny you and your supporters raise helps support children across Pakistan who don't have access to an education. Share the impact you and your supporters have created together!",
            svg: HomeSvgThree
        },
    ]

    const isFirstStep = step => {
        return step.count == 1;
    }

    const isLastStep = step => {
        return step.count == 3
    }
    return steps.map(step => {
        return <Box className={`StepBox StepBG-${step.count}`} key={step.count}>
            <Container className="StepContainer">
                {isFirstStep(step) ? <Typography variant="h4">Starting an education fundraiser is easy.</Typography> : null}
                <Stack className={`StepStack Step-${step.count}`}>
                    <Box className="StepContentBox">
                        <Typography variant="h5" className="StepTitle">STEP {step.count}</Typography>
                        <Divider />
                        <Typography className="StepContentSubtitle">{step.subtitle}</Typography>
                        <Typography className="StepContent" gutterBottom>{step.content}</Typography>
                        {
                            isLastStep(step) ? <MixPanelTrackedLink
                                gtmEvent={GTM_EVENTS.START_FUNDRAISER_CLICKED}
                                type="link"
                                className="CreateLink"
                                label="Click here to start your first fundraiser"
                                context="Home page"
                                color="inherit"
                                href={WEB_URL.CREATE_FUNDRAISER}
                            >
                                <Typography variant="bold">Click here to start your first fundraiser</Typography>
                            </MixPanelTrackedLink> : null
                        }
                    </Box>
                    <Box className="StepSvgBox">
                        <img src={step.svg} alt="" />
                    </Box>
                </Stack>
            </Container>
        </Box>
    })
}